import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    (async () => {
      try {
        const res = await api.processOAuthSession(sessionId);
        const { user, session_token } = res.data;
        if (!user || !session_token) {
          throw new Error('Invalid response from server');
        }
        login(user, session_token);
        // Clear hash from URL
        window.history.replaceState(null, '', window.location.pathname);
        if (user.is_new_user) {
          navigate('/generate', { state: { showOnboarding: true, user } });
        } else {
          navigate('/generate', { state: { user } });
        }
        toast.success(user.is_new_user ? `Welcome, ${user.name?.split(' ')[0] || 'there'}!` : `Welcome back, ${user.name?.split(' ')[0] || 'there'}!`);
      } catch (err) {
        console.error('Google sign-in error:', err?.response?.data || err?.message || err);
        // Retry once after a short delay (session might not be ready)
        try {
          await new Promise(r => setTimeout(r, 1500));
          const res = await api.processOAuthSession(sessionId);
          const { user, session_token } = res.data;
          if (!user || !session_token) throw new Error('Retry failed');
          login(user, session_token);
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/generate', { state: user.is_new_user ? { showOnboarding: true, user } : { user } });
          toast.success(`Welcome, ${user.name?.split(' ')[0] || 'there'}!`);
        } catch (retryErr) {
          console.error('Google sign-in retry failed:', retryErr?.response?.data || retryErr?.message);
          toast.error('Google sign-in failed. Please try again.');
          window.history.replaceState(null, '', window.location.pathname);
          navigate('/');
        }
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#0a0a0f] flex items-center justify-center">
      <div className="text-center space-y-4">
        <div className="w-12 h-12 border-2 border-[#c8a96e] border-t-transparent rounded-full spin mx-auto" />
        <p className="text-[#8a8799] text-sm">Signing you in...</p>
      </div>
    </div>
  );
}
